<template>
  <InfoCard title="Metrics">
    <ShikiHighlight
      class="model-params scrollbar shiki-model-params"
      :code="metrics"
      lang="yaml"
      theme="vitesse-light"
    />
  </InfoCard>
</template>

<script setup>
import ShikiHighlight from '@/components/ShikiHighlight.vue';
import InfoCard from '@/components/InfoCard.vue';

defineProps({
  metrics: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.model-params {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
}

.shiki-model-params {
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
}

:deep(.shiki-model-params pre) {
  padding: 16px;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff !important;
  color: #1e1e1e !important;
  white-space: pre-wrap;
  word-break: break-word;
}

:deep(.shiki-model-params code) {
  color: #1e1e1e !important;
  white-space: pre-wrap;
  word-break: break-word;
}

:deep(.shiki-model-params .line span) {
  color: #1e1e1e !important;
}
</style>
